// extracted by mini-css-extract-plugin
export default {"dark":"MaskIcon_dark__573Co","light":"MaskIcon_light__Zyn8K","common_mask_icon":"MaskIcon_common_mask_icon__+E-6Z"};